export const ADD_LEADERS = 'ADD_LEADERS';
export const LEADERS_FAILED = 'LEADERS_FAILED';
export const LEADERS_LOADING = 'LEADERS_LOADING';
export const ADD_FEEDBACKS = 'ADD_FEEDBACKS';
//export const DOCUMENT_ADD = 'DOCUMENT_ADD';